<rect
    width="14.6667"
    height="14.6667"
    x=".832031"
    y=".666626"
    fill="#4E5D78"
    rx="7.33333"
/><path
    fill="#fff"
    fill-rule="evenodd"
    d="M11.9102 4.76593c.1538.14098.1642.37995.0232.53375L7.0445 10.633a.377455.377455 0 0 1-.27028.1224c-.10301.0023-.20247-.0377-.27533-.1105L4.27666 8.42265c-.14753-.14754-.14753-.38673 0-.53426.14754-.14753.38673-.14753.53426 0l1.94323 1.94322 4.62225-5.04248c.141-.1538.38-.16419.5338-.0232Z"
    clip-rule="evenodd"
/>
